module.exports = __webpack_public_path__ + "static/media/latin-american-posters-davidson.8d6998b2.jpg";